import { Button, FormControl, Heading, HFlow, Modal, ModalBody, ModalFooter, Tag, Text, VFlow } from 'bold-ui'
import { Form, FormRenderProps } from 'components/form'
import { RadioFieldContainer } from 'components/form/field/RadioFieldContainer'
import { FonteIdadeGestacionalEnum } from 'graphql/types.generated'

import { formatIdadeGestacional } from '../../util-preNatal'
import { FonteIdadeGestacionalFormModel, fonteIdadeGestacionalRecord, metaFonteIdadeGestacional } from './model-fonteIg'
import { calcularDiferencaDiasReferencia } from './util-fonteIdadeGestacional'

interface FonteIdadeGestacionalModalFormProps {
  onClose: () => void
  onSave: (values: FonteIdadeGestacionalFormModel) => void
  recommendedFonteIg: FonteIdadeGestacionalEnum
  currentFonteIg: FonteIdadeGestacionalEnum
  igDum: number
  igEco: number
}

export const FonteIdadeGestacionalModalForm = (props: FonteIdadeGestacionalModalFormProps) => {
  const { onClose, onSave, recommendedFonteIg, currentFonteIg, igDum, igEco } = props

  const maiorMenorText = recommendedFonteIg === FonteIdadeGestacionalEnum.DUM ? 'menor' : 'maior'
  const referenciaDiferencaDias = calcularDiferencaDiasReferencia(igEco)

  const renderForm = (form: FormRenderProps<FonteIdadeGestacionalFormModel>) => {
    return (
      <Modal open onClose={onClose}>
        <ModalBody>
          <VFlow vSpacing={2}>
            <Heading level={1}>Alterar forma de cálculo da idade gestacional</Heading>
            <Text component='p'>
              O resultado da Ecografia Obstétrica indica uma diferença de idade gestacional {maiorMenorText} que{' '}
              {referenciaDiferencaDias} dias.{' '}
              <Text fontWeight='bold'>
                O Ministério da Saúde recomenda seguir a idade gestacional pela{' '}
                {fonteIdadeGestacionalRecord[recommendedFonteIg]}
              </Text>
              .
            </Text>
            <FormControl label='Qual dado utilizar para cálculo da idade gestacional?' required>
              <VFlow vSpacing={0.5}>
                <RadioFieldContainer
                  label={renderIgInfo(FonteIdadeGestacionalEnum.DUM, recommendedFonteIg, igDum)}
                  name={metaFonteIdadeGestacional.fonteIg}
                  value={FonteIdadeGestacionalEnum.DUM}
                  required
                />
                <RadioFieldContainer
                  label={renderIgInfo(FonteIdadeGestacionalEnum.US, recommendedFonteIg, igEco)}
                  name={metaFonteIdadeGestacional.fonteIg}
                  value={FonteIdadeGestacionalEnum.US}
                  required
                />
              </VFlow>
            </FormControl>
          </VFlow>
        </ModalBody>
        <ModalFooter>
          <HFlow justifyContent='flex-end'>
            <Button kind='primary' onClick={() => onSave(form.values)}>
              Salvar
            </Button>
          </HFlow>
        </ModalFooter>
      </Modal>
    )
  }

  return (
    <Form<FonteIdadeGestacionalFormModel>
      render={renderForm}
      onSubmit={onSave}
      initialValues={{ fonteIg: currentFonteIg }}
    />
  )
}

const renderIgInfo = (
  currentFonteIg: FonteIdadeGestacionalEnum,
  recommendedFonteIg: FonteIdadeGestacionalEnum,
  ig: number
) => {
  const isFonteIgRecomendada = currentFonteIg === recommendedFonteIg

  const igInfo = (
    <VFlow vSpacing={0}>
      <Text>Utilizar idade gestacional pela {fonteIdadeGestacionalRecord[currentFonteIg]}</Text>
      <Text color='secondary'>{formatIdadeGestacional(ig)}</Text>
    </VFlow>
  )

  return !isFonteIgRecomendada ? (
    igInfo
  ) : (
    <HFlow alignItems='center' hSpacing={1}>
      {igInfo}
      <Tag type='info'>Recomendada</Tag>
    </HFlow>
  )
}
